import { Route, Routes } from "react-router-dom"
import { ANNOUNCEMENT, ANNOUNCEMENTDETAIL, EDUCATIONSYSTEM, FAQ, GALLERYINFOGRAFIS, GALLERYVIDEO, LMS, LPTK, NEWS, NEWSDETAIL, ROOT, UKMPPG } from "./routes_name"
import LandingPage from "../pages/landing_page"
import AnnouncementPage from "../pages/announcement"
import AnnouncementDetailPage from "../pages/announcement/announcement_detail"
import NewsPage from "../pages/news"
import NewsDetailPage from "../pages/news/news_detail"
import FaqPage from "../pages/faq"
import EducationSystemPage from "../pages/education_system"
import LptkPage from "../pages/lptk"
import UkmPpgPage from "../pages/ukm_ppg"
import GalleryVideoPage from "../pages/gallery_video"
import GalleryInfografisPage from "../pages/gallery_infografis"
import LmsPage from "../pages/lms"

const Navigation = () => {
    return (
        <Routes>
            <Route
                path={ROOT}
                element={<LandingPage />}
            />
            <Route
                path={NEWS}
                element={<NewsPage />}
            />
            <Route
                path={`${NEWSDETAIL}/:code/:slug`}
                element={<NewsDetailPage />}
            />
            <Route
                path={ANNOUNCEMENT}
                element={<AnnouncementPage />}
            />
            <Route
                path={ANNOUNCEMENTDETAIL}
                element={<AnnouncementDetailPage />}
            />
            <Route
                path={EDUCATIONSYSTEM}
                element={<EducationSystemPage />}
            />
            <Route
                path={LPTK}
                element={<LptkPage />}
            />
            <Route
                path={LMS}
                element={<LmsPage />}
            />
            <Route
                path={UKMPPG}
                element={<UkmPpgPage />}
            />
            <Route
                path={GALLERYVIDEO}
                element={<GalleryVideoPage />}
            />
            <Route
                path={GALLERYINFOGRAFIS}
                element={<GalleryInfografisPage />}
            />
            <Route
                path={FAQ}
                element={<FaqPage />}
            />
        </Routes>
    )
}
export default Navigation